import { createSlice } from "@reduxjs/toolkit";

export const FLOW_TYPE_AMAN_STANDARD = "FLOW_TYPE_AMAN_STANDARD";

const initialState = {
    flowType: FLOW_TYPE_AMAN_STANDARD,
    currentStepIndex: 0,
    currentSubstepIndex: 0,
};

const amanFlowSlice = createSlice({
    name: "amanFlow",
    initialState,
    reducers: {
        setFlowType: (state, action) => {
            const data = action.payload;
            state.flowType = data.type;
            state.currentStepIndex = data.currentStepIndex || 0;
            state.currentSubstepIndex = data.currentSubstepIndex || 0;
        },
        setCurrentStepIndex: (state, action) => {
            state.currentStepIndex = action.payload;
            state.currentSubstepIndex = 0;
        },
        setCurrentSubstepIndex: (state, action) => {
            state.currentSubstepIndex = action.payload;
        },
        clearAmanFlow: () => initialState
    }
});

export const selectAmanFlow = (store) => store.amanFlow;
export const selectAmanFlowType = (store) => store?.amanFlow?.flowType;
export const selectAmanCurrentStepIndex = (store) => store?.amanFlow?.currentStepIndex;
export const selectAmanCurrentSubstepIndex = (store) => store.amanFlow?.currentSubstepIndex;

export const { 
    setFlowType, 
    setCurrentStepIndex, 
    setCurrentSubstepIndex, 
    clearAmanFlow 
} = amanFlowSlice.actions;

export default amanFlowSlice.reducer;
